import { render, staticRenderFns } from "./JourneyMap.vue?vue&type=template&id=57a63828&scoped=true"
import script from "./JourneyMap.vue?vue&type=script&lang=ts"
export * from "./JourneyMap.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a63828",
  null
  
)

export default component.exports